import { useCallback, useEffect, useState } from 'react';
import { GetAdminBlockedIpsAPI } from '../../../../api/AdminAPI';

/**
 * useAdminBlockedIps
 *
 * Hook responsável por carregar a lista de IPs bloqueados/rate-limited (Admin Geral).
 * Sem filtros ou paginação: a lista completa é retornada pela API de uma vez.
 *
 * @returns {{
 *   blockedIps: Array,
 *   total: number,
 *   currentlyBlocked: number,
 *   isLoading: boolean,
 *   error: string|null,
 *   refresh: Function,
 * }}
 */
function useAdminBlockedIps() {
  const [blockedIps, setBlockedIps] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentlyBlocked, setCurrentlyBlocked] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBlockedIps = useCallback(() => {
    setIsLoading(true);
    setError(null);
    GetAdminBlockedIpsAPI((response) => {
      if (!response || response.success === false) {
        setError(response?.error || 'Erro ao carregar os IPs bloqueados. Tente novamente.');
        setIsLoading(false);
        return;
      }
      setBlockedIps(response.blocked_ips || []);
      setTotal(response.total ?? (response.blocked_ips || []).length);
      setCurrentlyBlocked(response.currently_blocked ?? 0);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchBlockedIps();
  }, [fetchBlockedIps]);

  return {
    blockedIps,
    total,
    currentlyBlocked,
    isLoading,
    error,
    refresh: fetchBlockedIps,
  };
}

export default useAdminBlockedIps;
